import { getProviderDisplayLabel } from "@/pages/fluxextensions/helpers/aiProviderDisplay";

export type LuxorAgentType =
  | "luxor-medical-report"
  | "luxor-patient-case-analysis"
  | "luxor-patient-guidance";

export interface LuxorProviderContexts {
  medicalReportsProvider: string | null;
  discussionCaseProvider: string | null;
  guidanceProvider: string | null;
}

export function getProviderForLuxorType(
  selectedType: string,
  contexts: LuxorProviderContexts
): string | null {
  switch (selectedType) {
    case "luxor-medical-report":
      return contexts.medicalReportsProvider;
    case "luxor-patient-case-analysis":
      return contexts.discussionCaseProvider;
    case "luxor-patient-guidance":
      return contexts.guidanceProvider;
    default:
      return null;
  }
}

export function getProviderDisplayForLuxorType(
  selectedType: string,
  contexts: LuxorProviderContexts
): string {
  const provider = getProviderForLuxorType(selectedType, contexts);
  return getProviderDisplayLabel(provider);
}
